import { AccountRecord } from '../api/client'

/**
 * Returns the optimal display name for an account, falling back to other fields if the
 * account name is not available.
 */
export function getAccountDisplayName(account: AccountRecord): string {
    return (
        account.accountName ||
        account.serviceAccountUsername ||
        account.serviceAccountId ||
        'Unknown account'
    )
}

/**
 * Returns a secondary label for an account, preferring the service account username,
 * then the social media service display name, and finally the team name.
 */
export function getAccountSecondaryLabel(account: AccountRecord) {
    if (account.serviceAccountUsername) {
        return `@${account.serviceAccountUsername}`
    }

    return account.socialMediaServiceDisplayName || account.teamName || ''
}
